export const normalizePathname = (value: string) => {
  const normalized = `/${value.replace(/^\/+|\/+$/g, '')}`
  return normalized === '/' ? normalized : normalized.replace(/\/+$/g, '')
}
